module.exports = __webpack_public_path__ + "img/panos.a4dc6dcd.jpeg";